import { FastlyImage } from '@components/common/image'
import { COURSE_FEATURES } from '@components/locale-pages/home/courses'
import { Trans } from '@lingui/macro'
import { Check } from 'react-feather'

type Props = {
  title?: JSX.Element
  courseTitle: string
}

const CourseFeatures = ({ title, courseTitle }: Props) => {
  const features = COURSE_FEATURES[courseTitle]

  return (
    <div className="mt-20 flex flex-col text-grey container pt-10 mx-auto md:py-10">
      <h2 className="text-2xl md:text-2xl font-600 mb-8 leading-tight">
        {title}
      </h2>

      <div className="flex flex-wrap gap-4">
        <div className="relative shadow-md rounded-md w-full xl:w-80 p-8">
          <span className="absolute top-0 left-0 z-index-0">
            <FastlyImage
              src="/images/courses/outcome.svg"
              alt="AI & ML Features"
              className="absolute top-0 left-0 z-index-0"
              width={108}
              height={115}
            />{' '}
          </span>
          <h3 className="text-lg font-700 pl-8 pb-4 z-10 relative">
            <Trans>What you’ll learn</Trans>
          </h3>

          <div className="space-y-1 z-10 relative">
            {features.outcomes.map((outcome, index) => (
              <div key={index} className="flex items-start">
                <span
                  className="rounded-full bg-green-50 bg-opacity-50"
                  style={{ padding: '2px', marginTop: '5px' }}
                >
                  <Check
                    height={10}
                    width={10}
                    strokeWidth={3}
                    className="text-green-200"
                  />
                </span>
                <p className="ml-2 text-left">{outcome}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="relative shadow-md rounded-md w-full xl:w-1/2 p-8 flex flex-col">
          <span className="absolute top-0 left-0 z-index-0">
            <FastlyImage
              src="/images/courses/skills-bg.svg"
              alt="AI & ML Features"
              width={108}
              height={115}
            />
          </span>
          <h3 className="text-lg font-700 pl-8 pb-4 z-10 relative">
            <Trans>What you’ll learn</Trans>
          </h3>

          <div className="z-10 relative grid grid-cols-3 gap-3 text-center">
            {features.skills.map((skill, index) => (
              <div
                key={index}
                className="flex flex-col items-center justify-start gap-2"
              >
                <FastlyImage
                  src={`${skill.imagePath}.png`}
                  alt={skill.skillName}
                  webpSrc={`${skill.imagePath}.webp`}
                  width={42}
                  height={42}
                  className="h-12 w-12 object-contain"
                />
                <p className="ml-2 text-xs">{skill.skillName}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CourseFeatures
